import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ContentCombine from "core/Components/ContentCombine";

const ItemOutOfStock: React.FC = () => {
    const theme: Theme = useTheme();

    const style = css`
        display: flex;
        justify-content: center;
        min-width: ${theme.breakpoints.sizes.xs}px;
        height: 60px;
        color: white;
        background-color: ${theme.colours.red1};
        
        ${theme.breakpoints.down('md')} {
            height: 52px;
        }
    `;

    const textStyle = css`
        font-weight: ${theme.fonts.weights.bold};
        font-size: 20px;
        
        ${theme.breakpoints.down('md')} {
            font-size: 18px;
        }
    `;

    return (
        <div css={style}>
            <ContentCombine css={textStyle} unsetMinHeight={false}>
                Temporarily out of stock
            </ContentCombine>
        </div>
    );
};

export default ItemOutOfStock;
